import { lazy, Suspense, type ReactNode } from 'react';

import { useCurrentUserOrNull } from '@/shared/auth';
import { SessionSplash } from '@/shared/auth/SessionSplash';

const RestrictedSessionPage = lazy(async () => ({
  default: (await import('./RestrictedSessionPage')).RestrictedSessionPage,
}));

/**
 * Between the sign-in check and the shell: a session the administrator policy restricts (two-factor authentication to set
 * up, a password to replace — `user.restriction`) sees only that step. The API enforces the same (403
 * `auth.session_restricted` for everything else); this keeps the portal from rendering screens that could not load.
 */
export function RestrictedGate({ children }: { children: ReactNode }) {
  const user = useCurrentUserOrNull();
  if (user?.restriction) {
    return (
      <Suspense fallback={<SessionSplash />}>
        <RestrictedSessionPage user={user} />
      </Suspense>
    );
  }

  return children;
}
